import React, { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import countryList from "react-select-country-list";
import "./customTitleSelect.css";

const countryOptions = countryList().getData(); // [{ label: "Afghanistan", value: "AF" }, ...]

interface Props {
  label?: string;
  value: string; // now stores label, e.g. "Philippines"
  onChange: (value: string) => void;
  className?: string;
}

const CustomCountrySelect: React.FC<Props> = ({ value, onChange, label }) => {
  const [open, setOpen] = useState(false);

  const selectedLabel =
    value || label || "Select Country";

  return (
    <div className="custom-title-select">
      <div className="selector" onClick={() => setOpen((prev) => !prev)}>
        {selectedLabel}
        <span className="arrow">{open ? <FaCaretUp /> : <FaCaretDown />}</span>
      </div>
      {open && (
        <ul className="dropdown">
          {countryOptions.map((country) => (
            <li
              key={country.label}
              className={country.label === value ? "active" : ""}
              onClick={() => {
                onChange(country.label); // store label not value
                setOpen(false);
              }}
            >
              {country.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomCountrySelect;
